"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIMIT_PRODUCTS_FETCH_AMOUNT = exports.NO_SCHEDULE_GROUP_ID = void 0;
exports.NO_SCHEDULE_GROUP_ID = 'no-schedule';
exports.LIMIT_PRODUCTS_FETCH_AMOUNT = 1000;
//# sourceMappingURL=product-pricing.consts.js.map